import type { BoardMetadata } from "../model/board.js";
import type { SearchReport } from "../model/evaluation.js";
import type { PositionRecord } from "../model/position.js";

export function renderStateCompact(
  board: BoardMetadata,
  position: PositionRecord,
  report: SearchReport,
) {
  const lines: string[] = [];

  lines.push("# Attention Compact");
  lines.push("");
  lines.push("## Board");
  lines.push(`- session: ${board.sessionKey}`);
  lines.push(`- phase: ${report.phase}`);
  lines.push(`- tip: ${board.tipPositionId}`);
  lines.push(`- position: ${position.id}`);
  lines.push(
    `- attention: threats=${report.attentionVector.forcingThreats} proofs=${report.attentionVector.proofDebt} lineDebt=${report.attentionVector.lineDebt} entropy=${report.attentionVector.entropy}`,
  );
  lines.push("");
  lines.push("## Mainline");
  if (report.mainline.length === 0) {
    lines.push("- none");
  } else {
    for (const atomId of report.mainline) {
      lines.push(`- ${atomId}`);
    }
  }
  lines.push("");
  lines.push("## Candidate Lines");
  if ((report.candidateLines ?? []).length === 0) {
    lines.push("- none");
  } else {
    for (const candidate of report.candidateLines ?? []) {
      lines.push(`- ${candidate.pathId}: score=${candidate.score} selected=${candidate.selected}`);
      for (const reason of candidate.reasons.slice(0, 3)) {
        lines.push(`  - ${reason}`);
      }
    }
  }
  lines.push("");
  lines.push("## Threats");
  if (report.threats.length === 0) {
    lines.push("- none");
  } else {
    for (const threat of report.threats) {
      lines.push(`- ${threat.summary}`);
    }
  }
  lines.push("");
  lines.push("## Proof Debt");
  if (report.proofs.length === 0) {
    lines.push("- none");
  } else {
    for (const proof of report.proofs) {
      lines.push(`- ${proof.summary}`);
    }
  }
  lines.push("");
  lines.push("## Responses");
  if (report.responses.length === 0) {
    lines.push("- none");
  } else {
    for (const response of report.responses) {
      lines.push(`- ${response.reason}`);
      lines.push(`  command: ${JSON.stringify(response.command)}`);
    }
  }
  lines.push("");
  lines.push("## Position");
  lines.push(`- move: ${position.moveSummary}`);
  lines.push(`- evaluation: ${position.evaluation.summary}`);

  return lines.join("\n");
}
